import React, { FC } from "react";
import { useTranslation } from "react-i18next";

interface CoverageTagProps {
    isPublished: boolean;
}

const CoverageTag: FC<CoverageTagProps> = ({ isPublished }) => {
    const { t } = useTranslation();
    const tagConfig = {
        published: {
            text: t("worker-requests_coverage-published"),
            backgroundColor: "#E6F4EA",
            color: "#00642B",
        },
        notPublished: {
            text: t("worker-requests_no-coverage"),
            backgroundColor: "#FFFBEA",
            color: "#B26500",
        },
    };

    const currentConfig = isPublished ? tagConfig.published : tagConfig.notPublished;

    return (
        <div
            style={{
                display: "inline-flex",
                alignItems: "center",
                height: "20px",
                padding: "2px 8px",
                borderRadius: "4px",
                backgroundColor: currentConfig.backgroundColor,
                color: currentConfig.color,
                fontSize: "12px",
                fontWeight: "bold",
                width: "fit-content",
            }}
        >
            {currentConfig.text}
        </div>
    );
};

export default CoverageTag;
